import { useState } from 'react';
import { downloadVouchers, IVoucherDownloadParams, IVoucherResponse } from '../services/vouchersService';

interface UseVoucherDownloadReturn {
	isModalOpen: boolean;
	voucherData: IVoucherResponse[] | null;
	isLoading: boolean;
	error: string | null;
	handleDownloadVouchers: (params: IVoucherDownloadParams) => Promise<void>;
	handleForceUpdate: () => Promise<void>;
	closeModal: () => void;
}

export const useVoucherDownload = (): UseVoucherDownloadReturn => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [voucherData, setVoucherData] = useState<IVoucherResponse[] | null>(null);
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);
	const [lastParams, setLastParams] = useState<IVoucherDownloadParams | null>(null);

	const handleDownloadVouchers = async (params: IVoucherDownloadParams): Promise<void> => {
		try {
			setIsLoading(true);
			setError(null);
			setIsModalOpen(true);
			setLastParams(params);

			const response = await downloadVouchers(params);
			setVoucherData(response.data);
		} catch (err: any) {
			setError(err.message || 'Error al descargar vouchers');
			setVoucherData(null);
		} finally {
			setIsLoading(false);
		}
	};

	const handleForceUpdate = async (): Promise<void> => {
		if (!lastParams) {
			setError('No hay parámetros disponibles para forzar actualización');
			return;
		}

		try {
			setIsLoading(true);
			setError(null);

			const forceParams = { ...lastParams, force: true };
			const response = await downloadVouchers(forceParams);
			setVoucherData(response.data);
		} catch (err: any) {
			setError(err.message || 'Error al forzar actualización de vouchers');
			setVoucherData(null);
		} finally {
			setIsLoading(false);
		}
	};

	const closeModal = (): void => {
		setIsModalOpen(false);
		setVoucherData(null);
		setError(null);
		setIsLoading(false);
	};

	return {
		isModalOpen,
		voucherData,
		isLoading,
		error,
		handleDownloadVouchers,
		handleForceUpdate,
		closeModal,
	};
};
